"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = tslib_1.__importDefault(require("react"));
const prop_types_1 = tslib_1.__importDefault(require("prop-types"));
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const getMenuItems_1 = tslib_1.__importDefault(require("../menuItems/getMenuItems"));
const menuItemsPropTypes_1 = tslib_1.__importDefault(require("./menuItemsPropTypes"));
const MenuItems_1 = tslib_1.__importDefault(require("../menuItems/MenuItems"));
const DropdownSubmenu = props => {
    const { title, items, disabled, className } = props, remainingProps = tslib_1.__rest(props, ["title", "items", "disabled", "className"]);
    const classes = (0, classnames_1.default)('dropdown-submenu', disabled && 'disabled', className && className);
    return ((0, jsx_runtime_1.jsxs)("li", Object.assign({}, remainingProps, { className: classes }, { children: [(0, jsx_runtime_1.jsxs)("a", Object.assign({ className: 'submenu-title' }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: 'submenu-title-text' }, { children: title })), (0, jsx_runtime_1.jsx)("span", { className: 'rioglyph rioglyph-menu-right' })] })), (0, jsx_runtime_1.jsx)(MenuItems_1.default, { children: (0, getMenuItems_1.default)(items) })] })));
};
DropdownSubmenu.defaultProps = {
    title: '',
    items: [],
    disabled: false,
};
DropdownSubmenu.propTypes = {
    title: prop_types_1.default.oneOfType([prop_types_1.default.node, prop_types_1.default.string]),
    items: menuItemsPropTypes_1.default,
    disabled: prop_types_1.default.bool,
    className: prop_types_1.default.string,
};
exports.default = DropdownSubmenu;
